import { render, staticRenderFns } from "./basicTab.vue?vue&type=template&id=0b5f4253&scoped=true&"
import script from "./basicTab.vue?vue&type=script&lang=js&"
export * from "./basicTab.vue?vue&type=script&lang=js&"
import style0 from "./basicTab.vue?vue&type=style&index=0&id=0b5f4253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f4253",
  null
  
)

export default component.exports